var React = require('react');

function XNegative (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"30","cy":"30","r":"30","key":0}),React.createElement("path",{"fill":"#FFF","fillRule":"evenodd","d":"M16.1 16.1c1.5-1.5 3.8-1.5 5.3 0l8.6 8.6 8.6-8.6c1.5-1.5 3.8-1.5 5.3 0s1.5 3.8 0 5.3L35.3 30l8.6 8.6c1.5 1.5 1.5 3.8 0 5.3s-3.8 1.5-5.3 0L30 35.3l-8.6 8.6c-1.5 1.5-3.8 1.5-5.3 0s-1.5-3.8 0-5.3l8.6-8.6-8.6-8.6c-1.5-1.5-1.5-3.8 0-5.3z","key":1})]);
}

XNegative.defaultProps = {"baseProfile":"tiny","overflow":"visible","version":"1.2","viewBox":"0 0 60 60","xmlSpace":"preserve"};

module.exports = XNegative;

XNegative.default = XNegative;
